import * as React from 'react'

import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
   table: {
     minWidth: 300,
   },
   rowHeader: {
    fontSize: '15px',
    color: '#004f9f',
   },
   tdata: {
    fontFamily: "Gill Sans, sans-serif",
    fontSize: '16px',
    color: 'gray',
   },
   tEdit: {
    color: '#004f9f',
    cursor: 'pointer'
   }
 });


export function CustomList({ rows = [], headers= [], onHandleClick }) {
   const classes = useStyles();
   return (
      <Paper>
        <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead >
           <TableRow >
            {headers.map((hd) => (
               <TableCell className={classes.rowHeader} key={hd}>{hd}</TableCell>   
            ))}
         </TableRow>
        </TableHead>
        <TableBody>
          {rows.length > 0 ? Object.keys(rows).map((i) => (
          <TableRow key={rows[i].value}>
              <TableCell className={classes.tdata}>{rows[i].label}</TableCell>
              <TableCell className={classes.tdata}>{`${rows[i].percent} %`}</TableCell>
              <TableCell className={classes.tEdit} onClick={() => onHandleClick(rows[i])}><EditIcon /></TableCell>
          </TableRow>
          )): null}
        </TableBody>
      </Table>
    </Paper>
   )
} 
